import styled from "styled-components"

const Section = styled.section`
  margin-bottom: 32px;
`

export default Section
